/** Same-origin post-login return path. Rejects protocol-relative / open redirects. */
export function safeReturnPath(raw: string | null | undefined, fallback = '/'): string {
    if (!raw) return fallback;
    const path = raw.trim();
    if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) {
        return fallback;
    }
    return path;
}

export function currentReturnPath(): string {
    return `${window.location.pathname}${window.location.search || ''}`;
}
